import React from "react";
import Home24 from "@carbon/icons-react/lib/home/24";
import Time24 from "@carbon/icons-react/lib/time/24";
import { CommonRoutes, createRoute } from "./common-routes";

const AppRoutes = {
	...CommonRoutes,
	HOME: createRoute({
		id: "home",
		url: "/",
		component: "home/containers/HomeContainer",
		isNavItem: true,
		name: "Home",
		icon: <Home24 />
	}),
	SEASON: createRoute({
		id: "seasons",
		url: "/season",
		component: "season/containers/SeasonListContainer",
		isNavItem: true,
		name: "Seasons",
		icon: <Time24 />
	}),
	CURRENT_SEASON: createRoute({
		id: "season",
		url: "/season/:seasonId",
		component: "season/containers/CurrentSeasonContainer",
		name: "Current Season"
	}),
	SUPPORT: createRoute({
		id: "support",
		url: "/support",
		component: "support/containers/SupportContainer",
		name: "Support",
		icon: "gear"
	})
};

export { AppRoutes };
